// extracted by mini-css-extract-plugin
module.exports = {"molecule__item-availability-list-container":"styles_molecule__item-availability-list-container__R_UX7","item-availability-list-item":"styles_item-availability-list-item__E1M3F"};